<div *ngIf="thermo === null || thermo === undefined || thermo.on_line === undefined || thermo.on_line !== 1"
	class="grid m-0">
	<div class="col-12 py-2 bg-red-200 text-color flex align-items-center justify-content-center border-round-xl">
		{{ 'OFFLINE_NOT_REACHABLE_THERMO' | translate }}
	</div>
</div>

<form *ngIf="thermo && thermo.on_line === 1" [formGroup]="thermoForm" class="w-full">
	<div class="grid">
		<!-- TEMP & THERMO CONTROLS SEASONS -->
		<app-thermo-realtime-temp-info class="col-12" [thermoInput]="thermo"></app-thermo-realtime-temp-info>

		<!-- DIVIDER -->
		<div class="col-12">
			<div class="flex border-bottom-2 text-900 py-0 mx-3"></div>
		</div>

		<!-- SEASON_CONTROL -->
		<div class="col-12">
			<div class="flex align-items-center justify-content-center text-lg">
				{{ 'SEASON_CONTROL' | translate }}
			</div>
			<div class="flex flex-row align-items-center justify-content-center pt-2">
				<p-selectButton [options]="seasonControlOptions" formControlName="seasonControl"
					(onChange)="seasonControlChanged()" optionValue="value">
					<ng-template let-item pTemplate>
						<div class="flex align-items-center justify-content-center gap-2"
							[class]="!onExtendedMobile() ? 'w-10rem' : ''">
							<i [class]="item.icon"></i>
							<span>{{item.name}}</span>
						</div>
					</ng-template>
				</p-selectButton>
			</div>
		</div>

		<!-- STD / B&B -->
		<div *ngIf="isVisibileBnBModalityControl()" class="col-12">
			<div class="flex align-items-center justify-content-center text-lg gap-2">
				{{ 'TH_MODE' | translate }}
				<p-button *ngIf="!onExtendedMobile()" pTooltip="{{ 'TH_B&B_TOOLTIP' | translate }} {{ 'TH_B&B_OFF_TOOLTIP' | translate }}"
					tooltipPosition="right" icon="pi cm-info" size="large" [rounded]="false" [text]="true"
					severity="primary">
				</p-button>
			</div>
			<div class="flex flex-row align-items-center justify-content-center pt-2">
				<p-selectButton [options]="bnbModalityControlOptions" formControlName="bnbModalityControl" optionValue="value"
					(onChange)="bnbControlChanged()" optionDisabled="disabled">
					<ng-template let-item pTemplate>
						<div class="flex align-items-center justify-content-center gap-2"
							[class]="!onExtendedMobile() ? 'w-10rem' : 'w-5rem'">
							<i [class]="item.icon"></i>
							<span>{{item.name}}</span>
						</div>
					</ng-template>
				</p-selectButton>
			</div>
		</div>

		<!-- THERMAL_CONTROL (off, manual, auto etc.)-->
		<!-- is visible also for THOne BnB in Standard mode -->
		<div *ngIf="isVisibileThermalControl()" class="col-12">
			<div class="flex align-items-center justify-content-center text-lg gap-2">
				{{ 'THERMAL_CONTROL' | translate }}
				<p-button *ngIf="!onExtendedMobile()" pTooltip="{{'NOT_ALL_FUNCTIONS_AVAILABLE_ON_THIS_PLATFORM' | translate }}"
					tooltipPosition="right" icon="pi cm-info" size="large" [rounded]="false" [text]="true"
					severity="primary">
				</p-button>
			</div>
			<div class="flex flex-row align-items-center justify-content-center pt-2">
				<p-selectButton [options]="thermalControlOptions" formControlName="thermalControl" optionValue="value"
					(onChange)="thermalControlChanged()" optionDisabled="disabled">
					<ng-template let-item pTemplate>
						<div class="flex align-items-center justify-content-center gap-2"
							[class]="!onExtendedMobile() ? 'w-10rem' : 'w-5rem'">
							<i [class]="item.icon"></i>
							<span>{{item.name}}</span>
						</div>
					</ng-template>
				</p-selectButton>
			</div>
		</div>

		<!-- MANUAL NORMAL THERMO SET -->
		<div *ngIf="isVisibleManualControlTemperature()" class="col-12 pt-3">
			<!-- <div class="flex align-items-center justify-content-center text-lg pb-2">
					{{'SET_TEMPERATURE' | translate }}
				</div> -->
			<div class="flex justify-content-center">
				<div class="flex flex-column">
					<p-knob id="set-temperature" formControlName="temperature" size="250"
						[min]="thManualTempMin" [max]="thManualTempMax" [step]="thManualTempStepsValue"
						class="cursor-pointer" valueTemplate="{{spinnerManualTemp}}°C" textColor="var(--text-color, Black)"
						valueColor="#00B0ED" rangeColor="#CED1D4"
						(onChange)="sliderTempStop($event, sliderType.MANUAL_TEMP)">
					</p-knob>
					<div class="flex flex-row justify-content-between px-6">
						<p-button icon="pi cm-minus" severity="primary" [rounded]="false" [text]="false"
							(click)="setSliderButtonValue(buttonsTempSet.DECREASE, sliderType.MANUAL_TEMP)"
							[disabled]="isSliderMinMax('min', sliderType.MANUAL_TEMP)" />
						<p-button icon="pi cm-plus" severity="primary" [rounded]="false" [text]="false"
							(click)="setSliderButtonValue(buttonsTempSet.INCREASE, sliderType.MANUAL_TEMP)"
							[disabled]="isSliderMinMax('max', sliderType.MANUAL_TEMP)" />
					</div>
				</div>
			</div>
		</div>

		<!-- BNB_THERMAL_CONTROL (off, manual) -->
		<!-- visible only for THOne BnB in BnB mode -->
		<div *ngIf="isVisibileBnBThermalControl()" class="col-12">
			<div class="flex align-items-center justify-content-center text-lg">
				{{ 'THERMAL_CONTROL_B&B' | translate }}
			</div>
			<div class="flex flex-row align-items-center justify-content-center pt-2">
				<p-selectButton [options]="bnbThermalControlOptions" formControlName="bnbThermalControl" optionValue="value"
					(onChange)="bnbThermalControlChanged()" optionDisabled="disabled">
					<ng-template let-item pTemplate>
						<div class="flex align-items-center justify-content-center gap-2"
							[class]="!onExtendedMobile() ? 'w-10rem' : ''">
							<i [class]="item.icon"></i>
							<span>{{item.name}}</span>
						</div>
					</ng-template>
				</p-selectButton>
			</div>
		</div>

		<!-- BNB MANUAL THERMO SET -->
		<div *ngIf="isVisibleBnBManualControlTemperature() && !underTablet()" class="col-2"></div>

		<div *ngIf="isVisibleBnBManualControlTemperature()" [class]="!underTablet() ? 'col-8' : 'col-12'">
			<app-thermo-bnb-manual-control [thermoInput]="thermo" [camelCaseFormat]="false"
				(tempChange)="sliderTempStop($event, sliderType.MANUAL_TEMP)">
			</app-thermo-bnb-manual-control>
		</div>

		<div *ngIf="isVisibleBnBManualControlTemperature() && !underTablet()" class="col-2"></div>

		<!-- BNB MANUAL THERMO SET LIMITS -->
		<div *ngIf="isVisibleBnBManualControlTemperature()" [class]="!underTablet() ? 'col-8' : 'col-12'">
			<div class="flex align-items-center justify-content-center text-lg font-medium gap-2">
				<div class="pi pi-home"></div>
				{{ 'B&B' | translate }}
				<p-button *ngIf="!onExtendedMobile()" pTooltip="{{ 'TH_B&B_MANUAL_TOOLTIP' | translate }} {{ 'TH_B&B_OFF_TOOLTIP' | translate }}"
					tooltipPosition="right" icon="pi cm-info" size="large" [rounded]="false" [text]="true"
					severity="primary">
				</p-button>
			</div>
			<div class="border-1 border-bluegray-100 border-round surface-400 shadow-2">
				<div class="grid m-0">
					<!-- DELTA NEGATIVE and POSITIVE RANGE SLIDER -->
					<div class="col-12 pb-0">
						<div class="flex flex-row align-items-center justify-content-center text-lg gap-2">
							<div class="pi cm-termo"></div>
							{{ 'TH_B&B_CONTROLS' | translate }}
						</div>
					</div>
					<div class="col-12">
						<div class="flex flex-row align-items-center justify-content-center pt-3">
							<div class="flex w-40rem align-items-center gap-2">
								<div [class]="!onExtendedMobile() ? 'text-3xl' : 'text-xl'">{{ bnbDeltaTempRange[0] }}°C</div>
								<div class="flex flex-column w-full mx-4">
									<p-slider [(ngModel)]="bnbDeltaTempRange" [ngModelOptions]="{standalone: true}"
										[range]="true" class="w-full"
										[min]="getBnbDeltaRangeMin()" [max]="getBnbDeltaRangeMax()" [step]="thDeltaStepsValue"
										(onSlideEnd)="onChangeBnbDeltaTempRange()">
									</p-slider>
								</div>
								<div [class]="!onExtendedMobile() ? 'text-3xl' : 'text-xl'">{{ bnbDeltaTempRange[1] }}°C</div>
							</div>
						</div>
					</div>
					<!-- SETPOINT BnB ROUND SLIDER -->
					<div class="col-12">
						<div class="flex flex-column align-items-center justify-content-center">
							<p-knob id="set-temperature-b&b" formControlName="bnbTemperature" [size]="!onExtendedMobile() ? 240 : 200" [min]="thBnBTempMin"
								[max]="thBnBTempMax" [step]="thBnBTempStepsValue"
								class="cursor-pointer" valueTemplate="{{spinnerBnB}}°C" textColor="var(--text-color, Black)"
								valueColor="#00B0ED" rangeColor="#CED1D4" (onChange)="sliderTempStop($event, sliderType.BnB_MANUAL_TEMP)">
							</p-knob>
							<div class="flex align-items-center justify-content-around w-18rem">
								<p-button icon="pi cm-minus" severity="primary" [rounded]="false" [text]="false"
									(click)="setSliderButtonValue(buttonsTempSet.DECREASE, sliderType.BnB_MANUAL_TEMP)"
									[disabled]="isSliderMinMax('min', sliderType.BnB_MANUAL_TEMP)" />
								<p-button icon="pi cm-plus" severity="primary" [rounded]="false" [text]="false"
									(click)="setSliderButtonValue(buttonsTempSet.INCREASE, sliderType.BnB_MANUAL_TEMP)"
									[disabled]="isSliderMinMax('max', sliderType.BnB_MANUAL_TEMP)" />
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- BNB MANUAL Q&E -->
		<div *ngIf="isVisibleBnBManualControlTemperature()" [class]="!underTablet() ? 'col-4' : 'col-12'">
			<div class="flex align-items-center justify-content-center text-lg font-medium py-1 mb-1 gap-2">
				<div class="pi cm-quick-easy text-lg"></div>
				{{ 'PERMISSIONS_QUICK_EASY' | translate }}
			</div>
			<div class="border-1 border-bluegray-100 border-round mt-0 surface-400 shadow-2">
				<div class="grid m-0">
					<div class="col-12">
						<div class="flex justify-content-between flex-wrap border-bottom-2 border-100"
							[ngClass]="dynamicInputTextFormat('borderRow')">
							<div class="flex align-items-center justify-content-center" [ngClass]="dynamicInputTextFormat('label')">
								{{ 'PERMISSIONS_QUICK_EASY' | translate }}
							</div>
							<div class="flex align-items-center justify-content-center" [ngClass]="dynamicInputTextFormat('borderInput')">
								<p-inputSwitch inputId="th-quickeasy-enable-switch" formControlName="qneControl"
									(onChange)="quickEasyEnableControlChanged()"></p-inputSwitch>
							</div>
						</div>
					</div>
					<!-- QE COURTESY_TIME -->
					<div *ngIf="isVisibleQnEControls()" class="col-12 pt-0">
						<div class="flex flex-row align-items-center justify-content-center text-lg gap-2">
							<div class="pi pi-stopwatch"></div>
							{{ 'COURTESY_TIME_MINUTES' | translate }}
							<p-button *ngIf="!onExtendedMobile()" pTooltip="{{ 'TH_Q&E_TIME_COURTESY_TOOLTIP' | translate }}"
								tooltipPosition="top" icon="pi cm-info" size="large" [rounded]="false" [text]="true"
								severity="primary">
							</p-button>
						</div>
						<div class="flex flex-row align-items-center justify-content-center pt-1">
							<div class="flex w-40rem">
								<p-button pTooltip="{{ 'DECREASE' | translate }}" [disabled]="isTimeCourtesySliderMin()"
									tooltipPosition="bottom" icon="pi cm-minus" size="large" (click)="setSliderTimeCourtesyValue(-1)"
									[rounded]="false" [text]="true" severity="primary" class="pr-3">
								</p-button>
								<div class="select-none">{{ thQeMinValue }}</div>

								<div class="flex flex-column w-full mx-4">
									<p-inputNumber mode="decimal" [useGrouping]="false" variant="filled" formControlName="qneCourtesyTime"
										class="flex w-full" styleClass="flex w-full" inputStyleClass="surface-900"
										[min]="thQeMinValue" [max]="thQeMaxValue" [step]="thQeTimeStepsValue"
										(onBlur)="onChangeSliderTimeCourtesy()">
									</p-inputNumber>
									<p-slider formControlName="qneCourtesyTime" class="w-full" [step]="thQeTimeStepsValue" [min]="thQeMinValue" [max]="thQeMaxValue"
										(onSlideEnd)="onChangeSliderTimeCourtesy()">
									</p-slider>
								</div>

								<div class="select-none">{{ thQeMaxValue }}</div>
								<p-button pTooltip="{{ 'INCREASE' | translate}}" [disabled]="isTimeCourtesySliderMax()"
									tooltipPosition="bottom" icon="pi cm-plus" size="large" (click)="setSliderTimeCourtesyValue(1)"
									[rounded]="false" [text]="true" severity="primary" class="pl-3">
								</p-button>
							</div>
						</div>
					</div>
					<!-- QE STANDBY TEMP -->
					<div *ngIf="isVisibleQnEControls()" class="col-12 pt-2">
						<div class="flex flex-row align-items-center justify-content-center text-lg gap-2">
							<div class="pi cm-termo"></div>
							{{ 'STANDBY_TEMP' | translate }}
							<p-button *ngIf="!onExtendedMobile()" pTooltip="{{ 'TH_Q&E_STANDBY_TOOLTIP' | translate }}"
								tooltipPosition="bottom" icon="pi cm-info" size="large" [rounded]="false" [text]="true"
								severity="primary">
							</p-button>
						</div>
						<div class="flex flex-column align-items-center justify-content-center">
							<p-knob id="set-temperature-b&b" formControlName="qneTemperature" size="180" [min]="thQuickEasyTempMin"
								[max]="thQuickEasyTempMax" [step]="thQuickEasyTempStep" class="cursor-pointer" valueTemplate="{{spinnerQnEStandby}}°C"
								textColor="var(--text-color, Black)" valueColor="#00B0ED" rangeColor="#CED1D4"
								(onChange)="sliderTempStop($event, sliderType.QnE_STANDBY_TEMP)">
							</p-knob>
							<div class="flex align-items-center justify-content-around w-18rem">
								<p-button icon="pi cm-minus" severity="primary" [rounded]="false" [text]="false"
									(click)="setSliderButtonValue(buttonsTempSet.DECREASE, sliderType.QnE_STANDBY_TEMP)"
									[disabled]="isSliderMinMax('min', sliderType.QnE_STANDBY_TEMP)" />
								<p-button icon="pi cm-plus" severity="primary" [rounded]="false" [text]="false"
									(click)="setSliderButtonValue(buttonsTempSet.INCREASE, sliderType.QnE_STANDBY_TEMP)"
									[disabled]="isSliderMinMax('max', sliderType.QnE_STANDBY_TEMP)" />
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</form>